export interface Chapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateDate: string;
  tags: string[];
  chapters: Chapter[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '皇女给叛徒刻上烙印',
    author: '冬日',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20webtoon%20cover%20style%20illustration%20of%20an%20elegant%20princess%20with%20long%20silver%20hair%20holding%20a%20magical%20seal%2C%20soft%20warm%20lighting%2C%20fantasy%20royal%20palace%20background%2C%20romantic%20atmosphere%2C%20detailed%20character%20design%2C%20soft%20pastel%20colors%2C%20manhwa%20art%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '帝国的皇女为了平定叛乱，不得不给叛徒首领刻上烙印。然而，这个烙印却将两人的命运紧紧绑在了一起。在复仇与救赎之间，他们的故事就此展开。这部韩国漫画以其精美的画风和扣人心弦的剧情，成为近期最受读者喜爱的韩漫作品之一，带你体验王权争斗下的爱恨纠葛。',
    category: 'romance',
    status: '连载中',
    rating: 9.4,
    views: 1825000,
    updateDate: '2026-08-04',
    tags: ['古风', '恋爱', '宫廷', '复仇'],
    chapters: [
      { id: 1, title: '第1话 命运的相遇', updateDate: '2026-01-15' },
      { id: 2, title: '第2话 烙印的秘密', updateDate: '2026-01-22' },
      { id: 3, title: '第3话 宫廷暗流', updateDate: '2026-01-29' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法与学园',
    author: '星野',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20featuring%20a%20young%20swordsman%20with%20dark%20hair%20holding%20a%20glowing%20magical%20sword%20in%20a%20fantasy%20academy%20setting%2C%20warm%20golden%20light%2C%20magical%20particles%20floating%2C%20detailed%20costume%20design%2C%20manhwa%20illustration%20style%2C%20clean%20background%20with%20castle%20silhouette&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '平凡少年意外进入魔法学园，发现自己拥有传说中的剑术天赋。在学园中，他结识了各具特色的伙伴，一同对抗黑暗势力的威胁。这部韩国漫画融合了经典的奇幻元素与热血战斗，画面表现力极强，每一话都让人欲罢不能，是韩漫屋人气榜TOP3的必读佳作。',
    category: 'fantasy',
    status: '连载中',
    rating: 9.2,
    views: 1560000,
    updateDate: '2026-08-03',
    tags: ['奇幻', '冒险', '学园', '魔法'],
    chapters: [
      { id: 1, title: '第1话 入学典礼', updateDate: '2026-02-01' },
      { id: 2, title: '第2话 初次试炼', updateDate: '2026-02-08' },
    ],
  },
  {
    id: 3,
    title: '社长的小娇妻',
    author: '青空',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20of%20a%20beautiful%20young%20woman%20in%20office%20attire%20with%20a%20handsome%20CEO%20man%20in%20suit%20behind%20her%2C%20modern%20office%20background%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20manhwa%20art%20style%2C%20clean%20elegant%20composition&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '刚毕业的小职员误打误撞成为了霸道社长的契约妻子，两个性格截然不同的人被迫住在一起。从最初的互不顺眼到逐渐心动，一段甜蜜又搞笑的办公室恋爱故事就此展开。这部韩国漫画以其轻松幽默的剧情和超甜的互动，让无数韩漫屋读者沉迷其中，是恋爱类韩漫的经典之作。',
    category: 'romance',
    status: '连载中',
    rating: 9.0,
    views: 2340000,
    updateDate: '2026-08-05',
    tags: ['现代', '恋爱', '办公室', '契约婚姻'],
    chapters: [
      { id: 1, title: '第1话 意外的契约', updateDate: '2025-11-10' },
      { id: 2, title: '第2话 同居第一天', updateDate: '2025-11-17' },
    ],
  },
  {
    id: 4,
    title: '重生之都市仙尊',
    author: '墨白',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20featuring%20a%20powerful%20male%20character%20with%20flowing%20robes%20surrounded%20by%20energy%20waves%20in%20a%20modern%20city%20setting%2C%20dramatic%20lighting%2C%20dynamic%20pose%2C%20martial%20arts%20theme%2C%20manhwa%20illustration%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '修仙界至尊在渡劫失败后重生到现代都市，以一个普通高中生的身份重新开始。他凭借前世的修行记忆，在都市中一步步崛起，惩恶扬善，揭开前世的惊天秘密。这部韩国漫画将修仙与现代都市完美结合，打斗场面炫酷震撼，剧情节奏紧凑，是动作类韩漫的巅峰之作。',
    category: 'action',
    status: '连载中',
    rating: 9.5,
    views: 3210000,
    updateDate: '2026-08-05',
    tags: ['都市', '修仙', '重生', '热血'],
    chapters: [
      { id: 1, title: '第1话 天劫降临', updateDate: '2026-03-20' },
      { id: 2, title: '第2话 新生', updateDate: '2026-03-27' },
    ],
  },
  {
    id: 5,
    title: '秘密花园',
    author: '月下',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%20of%20two%20handsome%20young%20men%20standing%20close%20in%20a%20beautiful%20garden%20with%20flowers%2C%20soft%20romantic%20atmosphere%2C%20gentle%20warm%20light%2C%20delicate%20character%20design%2C%20manhwa%20art%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '两个身处完全不同世界的男子，在一个秘密花园中不期而遇。一个是出身名门的钢琴家，一个是默默无闻的花匠。他们在花园中分享彼此的喜怒哀乐，一段不被世俗理解的感情悄然生长。这部韩国漫画画面唯美细腻，情感描绘真挚动人，是耽美类韩漫中的经典之作。',
    category: 'bl',
    status: '已完结',
    rating: 9.3,
    views: 1890000,
    updateDate: '2026-07-15',
    tags: ['耽美', '文艺', '音乐', '治愈'],
    chapters: [
      { id: 1, title: '第1话 花园初遇', updateDate: '2025-06-01' },
      { id: 2, title: '第2话 琴声悠扬', updateDate: '2025-06-08' },
      { id: 3, title: '第3话 最后的乐章（完结）', updateDate: '2026-07-15' },
    ],
  },
  {
    id: 6,
    title: '时间的缝隙',
    author: '夜澜',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20thriller%20manhwa%20cover%20with%20a%20mysterious%20clock%20tower%20and%20a%20detective%20character%20in%20trench%20coat%2C%20dark%20moody%20atmosphere%2C%20dramatic%20shadows%2C%20suspense%20theme%2C%20manhwa%20illustration%20style%2C%20clean%20mysterious%20composition&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '刑警林正宇在调查一起连环失踪案时，发现所有受害者都曾在同一时间点出现在同一地点。随着调查深入，他发现自己陷入了一个关于时间的巨大阴谋之中。这部韩国漫画悬疑氛围浓厚，每一个细节都暗藏伏笔，推理过程环环相扣，是悬疑类韩漫中不可多得的烧脑佳作。',
    category: 'thriller',
    status: '连载中',
    rating: 9.1,
    views: 1250000,
    updateDate: '2026-08-02',
    tags: ['悬疑', '推理', '时间', '都市'],
    chapters: [
      { id: 1, title: '第1话 失踪者', updateDate: '2026-04-05' },
      { id: 2, title: '第2话 时间线索', updateDate: '2026-04-12' },
    ],
  },
  {
    id: 7,
    title: '宅男逆袭日记',
    author: '柚子',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%20of%20a%20goofy%20gamer%20boy%20with%20headphones%20in%20a%20messy%20room%20suddenly%20transformed%20into%20a%20cool%20character%2C%20bright%20colorful%20fun%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '一个整天宅在家里打游戏的废柴少年，某天意外获得了一个逆袭系统。系统让他必须完成各种奇葩任务来提升自己。从健身到社交，从学习到穿搭，一场啼笑皆非的逆袭之旅就此开始。这部韩国漫画笑点密集，画风活泼可爱，是韩漫屋搞笑类排名第一的下饭神作。',
    category: 'comedy',
    status: '连载中',
    rating: 8.8,
    views: 980000,
    updateDate: '2026-08-03',
    tags: ['搞笑', '系统', '校园', '逆袭'],
    chapters: [
      { id: 1, title: '第1话 系统的降临', updateDate: '2026-05-10' },
      { id: 2, title: '第2话 第一个任务', updateDate: '2026-05-17' },
    ],
  },
  {
    id: 8,
    title: '猫与咖啡店',
    author: '暖阳',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%20of%20a%20cozy%20cat%20cafe%20with%20a%20gentle%20female%20barista%20and%20cute%20cats%2C%20warm%20cozy%20atmosphere%2C%20soft%20sunlight%20through%20windows%2C%20manhwa%20illustration%20style%2C%20clean%20heartwarming%20composition&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '失去工作的都市女孩在街角发现了一家猫咪咖啡店，店主是一位沉默寡言但内心温暖的男人。在咖啡的香气和猫咪的陪伴中，她逐渐治愈了内心的伤痛，也发现了生活中被忽略的美好。这部韩国漫画温暖治愈，每一话都像一杯热咖啡般抚慰心灵，是日常类韩漫的治愈担当。',
    category: 'slice-of-life',
    status: '已完结',
    rating: 9.6,
    views: 1450000,
    updateDate: '2026-06-20',
    tags: ['日常', '治愈', '咖啡', '猫'],
    chapters: [
      { id: 1, title: '第1话 迷路的猫', updateDate: '2025-08-01' },
      { id: 2, title: '第2话 猫的咖啡店', updateDate: '2025-08-08' },
      { id: 3, title: '第3话 温暖的家（完结）', updateDate: '2026-06-20' },
    ],
  },
  {
    id: 9,
    title: '复仇公主的华丽回归',
    author: '琉璃',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20drama%20manhwa%20cover%20of%20a%20beautiful%20woman%20in%20elegant%20gown%20with%20cold%20determined%20expression%20returning%20to%20a%20grand%20ballroom%2C%20dramatic%20lighting%2C%20revenge%20theme%2C%20manhwa%20art%20style%2C%20clean%20powerful%20composition&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    description: '被陷害而流放海外的公主，十年后以全新身份华丽回归。她不再是那个天真无邪的少女，而是一个运筹帷幄的复仇者。在贵族社交圈中步步为营，她要让曾经伤害过她的人付出代价。这部韩国漫画剧情张力十足，女主智商在线，复仇过程大快人心，是剧情类韩漫的口碑之王。',
    category: 'drama',
    status: '连载中',
    rating: 9.7,
    views: 2780000,
    updateDate: '2026-08-05',
    tags: ['宫廷', '复仇', '女强', '权谋'],
    chapters: [
      { id: 1, title: '第1话 流放之夜', updateDate: '2026-01-05' },
      { id: 2, title: '第2话 十年之后', updateDate: '2026-01-12' },
    ],
  },
  {
    id: 10,
    title: '武道巅峰',
    author: '铁拳',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20of%20a%20muscular%20martial%20artist%20in%20fighting%20stance%20with%20energy%20aura%2C%20epic%20mountain%20background%2C%20dynamic%20action%20pose%2C%20intense%20atmosphere%2C%20manhwa%20illustration%20style%2C%20clean%20powerful%20composition&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    description: '在一个以武为尊的世界里，少年秦烈怀揣着成为最强武道家的梦想踏上修行之路。他从最底层的武者开始，历经无数次生死战斗，一步步迈向武道巅峰。这部韩国漫画战斗场面极具视觉冲击力，成长线热血澎湃，是动作类韩漫中的硬核代表。',
    category: 'action',
    status: '连载中',
    rating: 9.0,
    views: 1670000,
    updateDate: '2026-08-04',
    tags: ['格斗', '热血', '成长', '竞技'],
    chapters: [
      { id: 1, title: '第1话 开始的试炼', updateDate: '2026-02-15' },
      { id: 2, title: '第2话 突破极限', updateDate: '2026-02-22' },
    ],
  },
  {
    id: 11,
    title: '恋爱操作团',
    author: '樱桃',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20cover%20of%20a%20group%20of%20young%20people%20in%20colorful%20fashionable%20clothes%20posing%20playfully%2C%20bright%20cheerful%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20fun%20composition&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    description: '大学校园里有一个神秘组织——恋爱操作团。他们专门帮助暗恋者策划告白方案，成功率高达99%。然而当操作团成员们自己陷入感情旋涡时，才发现恋爱这件事远比想象中复杂。这部韩国漫画甜度爆表，CP线丰富多样，是恋爱类韩漫中的欢乐担当。',
    category: 'romance',
    status: '已完结',
    rating: 8.9,
    views: 1120000,
    updateDate: '2026-05-30',
    tags: ['校园', '恋爱', '搞笑', '群像'],
    chapters: [
      { id: 1, title: '第1话 神秘组织', updateDate: '2025-09-01' },
      { id: 2, title: '第2话 第一个委托人', updateDate: '2025-09-08' },
      { id: 3, title: '第3话 告白大作战（完结）', updateDate: '2026-05-30' },
    ],
  },
  {
    id: 12,
    title: '异世界食堂',
    author: '风味',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20a%20magical%20restaurant%20filled%20with%20delicious%20food%20and%20fantasy%20creatures%20as%20customers%2C%20warm%20inviting%20atmosphere%2C%20detailed%20food%20illustration%2C%20manhwa%20art%20style%2C%20clean%20cozy%20composition&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    description: '一家普通的餐厅每到周末就会连接到异世界，各种奇幻种族的客人慕名而来品尝人间的美味。店主老张用一道道家常菜征服了龙族、精灵、兽人的味蕾，也在异世界掀起了一场美食革命。这部韩国漫画脑洞大开，美食与奇幻的碰撞让人眼前一亮，是不可错过的奇幻美食佳作。',
    category: 'fantasy',
    status: '连载中',
    rating: 9.1,
    views: 890000,
    updateDate: '2026-08-01',
    tags: ['奇幻', '美食', '治愈', '异世界'],
    chapters: [
      { id: 1, title: '第1话 门那边的世界', updateDate: '2026-06-10' },
      { id: 2, title: '第2话 龙族的美食家', updateDate: '2026-06-17' },
    ],
  },
];

export const featuredIds = [1, 4, 9, 5, 8, 3];

export const popularIds = [4, 9, 5, 1, 2, 10];

export const latestIds = [3, 4, 9, 1, 7, 6];